<template>
  <section class="video-jumbotron-section">
    <InlineVideo
      ref="video"
      class="section__video stick-all-corners h-100 w-100"
      :poster="assets.INTRO_VIDEO_POSTER"
      :sources="sources"
    />
    <IntersectionObserver
      class="stick-all-corners h-100 w-100"
      :handler="intersectionHandler"
      :options="{
        threshold: 0.25,
      }"
    />

    <div class="stick-all-corners flex-center flex-column">
      <div class="section__content container text-center py-5">
        <JoinHeading
          :level="1"
          class="text-center mb-6 text-white"
        >
          {{ $t('join.section.banner.title') }}
        </JoinHeading>

        <JoinButton
          :href="assets.LINK_TO_CREATOR"
        >
          {{ $t('join.section.banner.cta.label') }}
        </JoinButton>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import IntersectionObserver from '@/scripts/Components/commons/shared/intersection-observer.vue';
import { JoinBaseComponent } from '../common/JoinBaseComponent';
import JoinHeading from '../common/JoinHeading.ts.vue';
import JoinButton from '../common/join-button.vue';
import InlineVideo from '../common/inline-video.vue';
import { BannerVideo } from '../assets/media';

export default JoinBaseComponent.extend({
  components: {
    JoinHeading,
    JoinButton,
    InlineVideo,
    IntersectionObserver,
  },
  data() {
    return {
      assets: {
        INTRO_VIDEO_POSTER: BannerVideo.poster,
        LINK_TO_CREATOR: 'https://creator.viddsee.com',
      },
      sources: [
        {
          src: BannerVideo.video.vp9,
          type: 'video/webm; codecs="vp9"',
        },
        {
          src: BannerVideo.video.vp8,
          type: 'video/webm; codecs="vp8"',
        },
        {
          src: BannerVideo.video.x264,
          type: 'video/mp4; codecs="avc1.42001e"',
        },
      ],
    };
  },
  methods: {
    async intersectionHandler({ isIntersecting }: IntersectionObserverEntry, isSupported: boolean): Promise<void> {
      const videoEl = (this.$refs.video as InstanceType<typeof InlineVideo>).$el as HTMLVideoElement;

      if (isIntersecting || !isSupported) {
        try {
          const playPromise = videoEl.play();
          if (playPromise !== undefined) {
            await Promise.resolve();
          }
        } catch {
          // Doesn't matter. It is ok for video to fail
        }
        return;
      }

      return videoEl.pause();
    },
  },
});
</script>

<style scoped lang="scss">
@import '~@/scripts/pages/onepager/styles/variables-entry';

// Do full screening and z-index sorting
.video-jumbotron-section {
  $navbar-height-sm: 56px;
  $navbar-height-xs: $navbar-height-sm;

  position: relative;
  min-height: 337px; // Since the child is an absolute content, child's height no longer affect the height of this element. We need to manually set height now
  height: calc(100vh - #{$navbar-height-xs});
  overflow: hidden;

  @include media-breakpoint-up(sm) {
    height: 50vw;
    max-height: calc(100vh - #{$navbar-height-sm});
  }
}

.section__content {
  max-width: 320px;
  margin: 0 auto;
  margin-top: -4em;
  @include media-breakpoint-up(sm) {
    max-width: 640px;
  }
}
.section__video {
  object-fit: cover;
}
</style>
